import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './StatsBar.module.css';

function StatsBar() {
  const { i18n } = useTranslation();
  const isID = i18n.language === 'id';

  const stats = [
    {
      num: '30\u201370%',
      label: isID
        ? 'anak dengan ASD umumnya mengalami masalah pencernaan (GI)'
        : 'of children with ASD experience GI issues',
    },
    {
      num: '3',
      label: isID
        ? 'platform skrining tervalidasi dan berbasis bukti ilmiah'
        : 'validated, evidence-based screening tools',
    },
    {
      num: '100%',
      label: isID
        ? 'gratis dan mudah digunakan oleh caregiver'
        : 'free and easy to use for caregivers',
    },
  ];

  return (
    <section className={styles.stats}>
      <div className={styles.grid}>
        {stats.map((s, i) => (
          <div key={i} className={styles.item}>
            <div className={styles.number}>{s.num}</div>
            <div className={styles.label}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default StatsBar;